import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../auth";

const SidePanel = () => (
  <aside className="auth-side">
    <div>
      <div className="brand-box"><img src="/rotasaude-logo.png" alt="RotaSaúde" /></div>
      <h1>Planejamento que leva cuidado até você.</h1>
      <p>Gestão completa de transporte e remoção de pacientes: pacientes, orçamentos, rotas, frota, equipe e financeiro — agora em nuvem, multiempresa e seguro.</p>
      <div className="pill-list">
        <span className="pill">✓ Orçamentos e remoções</span>
        <span className="pill">✓ Financeiro por remoção realizada</span>
        <span className="pill">✓ PDFs e WhatsApp</span>
        <span className="pill">✓ Multiempresa com dados isolados</span>
      </div>
    </div>
    <div className="foot">RotaSaúde SaaS • Tecnologia a serviço da vida.</div>
  </aside>
);

export default function Login() {
  const { login, registerCompany, formatApiErrorDetail } = useAuth();
  const nav = useNavigate();
  const [mode, setMode] = useState("login");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [f, setF] = useState({ email: "", password: "", companyName: "", adminName: "", phone: "", segment: "remocao" });
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      let u;
      if (mode === "login") u = await login(f.email, f.password);
      else u = await registerCompany({ companyName: f.companyName, adminName: f.adminName, email: f.email, password: f.password, phone: f.phone, segment: f.segment });
      nav(u.role === "superadmin" ? "/admin" : "/", { replace: true });
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-wrap">
      <SidePanel />
      <div className="auth-panel">
        <form className="auth-card" onSubmit={submit}>
          <div className="mobile-logo"><img src="/rotasaude-logo.png" alt="RotaSaúde" /></div>
          <h2>{mode === "login" ? "Entrar na plataforma" : "Criar conta da empresa"}</h2>
          <p className="sub">{mode === "login" ? "Acesse a operação da sua empresa." : "Comece com 14 dias grátis. Sem cartão."}</p>
          {error && <div className="auth-error" data-testid="auth-error">{error}</div>}
          {mode === "register" && (
            <>
              <label className="auth-field">Nome da empresa
                <input data-testid="reg-company" value={f.companyName} onChange={set("companyName")} required placeholder="Ex.: Remoções Vida" />
              </label>
              <label className="auth-field">Seu nome (administrador)
                <input data-testid="reg-admin-name" value={f.adminName} onChange={set("adminName")} required placeholder="Nome do responsável" />
              </label>
              <label className="auth-field">Segmento da empresa
                <select data-testid="reg-segment" value={f.segment} onChange={set("segment")}>
                  <option value="remocao">Empresa de remoção / ambulância</option>
                  <option value="clinica">Clínica com frota (traslados)</option>
                </select>
              </label>
              <label className="auth-field">Telefone / WhatsApp
                <input data-testid="reg-phone" value={f.phone} onChange={set("phone")} placeholder="(11) 99999-9999" />
              </label>
            </>
          )}
          <label className="auth-field">E-mail
            <input data-testid="auth-email" type="email" value={f.email} onChange={set("email")} required placeholder="voce@empresa.com.br" />
          </label>
          <label className="auth-field">Senha
            <input data-testid="auth-password" type="password" value={f.password} onChange={set("password")} required placeholder="Sua senha" />
          </label>
          <button className="auth-btn" type="submit" disabled={loading} data-testid="auth-submit">
            {loading ? "Aguarde…" : mode === "login" ? "Entrar" : "Criar conta e começar"}
          </button>
          {mode === "login" && (
            <div className="auth-links">
              <span />
              <a href="/forgot-password" data-testid="forgot-link">Esqueci minha senha</a>
            </div>
          )}
          <div className="auth-toggle">
            {mode === "login" ? (
              <>Não tem conta? <button type="button" onClick={() => { setMode("register"); setError(""); }} data-testid="go-register">Criar conta da empresa</button></>
            ) : (
              <>Já tem conta? <button type="button" onClick={() => { setMode("login"); setError(""); }} data-testid="go-login">Fazer login</button></>
            )}
          </div>
        </form>
      </div>
    </div>
  );
}
